"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_spring_1 = require("react-spring");
var visibilityjs_1 = __importDefault(require("visibilityjs"));
var usePoppingQueue_1 = __importDefault(require("@seaweb/coral/hooks/usePoppingQueue"));
var useUnmountedEffect_1 = __importDefault(require("@seaweb/coral/hooks/useUnmountedEffect"));
var getRoot_1 = __importStar(require("@seaweb/coral/utils/getRoot"));
var Elevator_1 = require("@seaweb/coral/components/Elevator");
var PusherContext_1 = __importStar(require("./PusherContext"));
var PusherItem_1 = __importDefault(require("./PusherItem"));
exports.Queue = styled_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  ", "\n"], ["\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var _zindex = _a._zindex;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    z-index: ", ";\n  "], ["\n    z-index: ", ";\n  "])), _zindex);
}, function (_a) {
    var _position = _a._position;
    switch (_position) {
        case PusherContext_1.PusherPositions.MiddleCenter:
            return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          align-items: center;\n        "], ["\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n          align-items: center;\n        "])));
        case PusherContext_1.PusherPositions.TopCenter:
            return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n          top: 0;\n          left: 50%;\n          transform: translateX(-50%);\n          align-items: center;\n        "], ["\n          top: 0;\n          left: 50%;\n          transform: translateX(-50%);\n          align-items: center;\n        "])));
        case PusherContext_1.PusherPositions.TopLeft:
            return styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          top: 0;\n          left: 8px;\n        "], ["\n          top: 0;\n          left: 8px;\n        "])));
        case PusherContext_1.PusherPositions.TopRight:
            return styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          top: 0;\n          right: 8px;\n          align-items: flex-end;\n        "], ["\n          top: 0;\n          right: 8px;\n          align-items: flex-end;\n        "])));
        case PusherContext_1.PusherPositions.BottomCenter:
            return styled_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          bottom: 8px;\n          left: 50%;\n          transform: translateX(-50%);\n          align-items: center;\n        "], ["\n          bottom: 8px;\n          left: 50%;\n          transform: translateX(-50%);\n          align-items: center;\n        "])));
        case PusherContext_1.PusherPositions.BottomLeft:
            return styled_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n          bottom: 8px;\n          left: 8px;\n        "], ["\n          bottom: 8px;\n          left: 8px;\n        "])));
        case PusherContext_1.PusherPositions.BottomRight:
            return styled_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n          bottom: 8px;\n          right: 8px;\n          align-items: flex-end;\n        "], ["\n          bottom: 8px;\n          right: 8px;\n          align-items: flex-end;\n        "])));
        default:
            return null;
    }
});
var from = { opacity: 0, height: 0, paddingTop: 0 };
var Pusher = function (_a) {
    var child = _a.children, _b = _a.container, container = _b === void 0 ? (getRoot_1.warnSSR('Pusher', 'container'), getRoot_1.default()) : _b, queueProps = __rest(_a, ["children", "container"]);
    var _c = usePoppingQueue_1.default(), queue = _c.queue, push = _c.push, pop = _c.pop, pause = _c.pause, resume = _c.resume, stop = _c.stop;
    var ctx = {
        push: function (children, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.duration, duration = _c === void 0 ? 6000 : _c, _d = _b.position, position = _d === void 0 ? PusherContext_1.PusherPositions.TopCenter : _d;
            var key = push({ position: position, children: children }, duration);
            return function () { return pop(key); };
        },
    };
    useUnmountedEffect_1.default(function () { return queue.forEach(function (item) { return stop(item.key); }); });
    var elsRef = react_1.useRef({});
    var transitions = react_spring_1.useTransition(queue, function (i) { return i.key; }, {
        from: from,
        enter: function (item) { return function (next) { return __awaiter(void 0, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        el = elsRef.current[item.key];
                        return [4, next({
                                opacity: 1,
                                height: el ? el.clientHeight : null,
                                paddingTop: 8,
                            })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        }); }; },
        leave: from,
    });
    react_1.useEffect(function () {
        var listener = visibilityjs_1.default.change(function (e, state) {
            if (state === 'hidden')
                queue.forEach(function (i) { return pause(i.key); });
            if (state === 'visible')
                queue.forEach(function (i) { return resume(i.key); });
        });
        return function () { return visibilityjs_1.default.unbind(listener); };
    }, [queue, pause, resume]);
    var zIndex = Elevator_1.useElevation(900);
    var content = Object.values(PusherContext_1.PusherPositions)
        .map(function (position) { return ({
        position: position,
        ts: transitions.filter(function (t) { return t.item.data.position === position; }),
    }); })
        .map(function (_a) {
        var position = _a.position, ts = _a.ts;
        return (react_1.default.createElement(exports.Queue, __assign({ key: position, "data-coral-pusher-queue-position": position, _position: position, _zindex: zIndex }, queueProps), ts.map(function (_a) {
            var key = _a.key, _b = _a.item, queueKey = _b.key, children = _b.data.children, props = _a.props;
            return (react_1.default.createElement(PusherItem_1.default, { key: key, queueKey: queueKey, pop: function () { return pop(queueKey); }, pause: function () { return pause(queueKey); }, resume: function () { return resume(queueKey); }, style: props, elementsRef: elsRef }, children));
        })));
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        container === null ? content : react_dom_1.createPortal(content, container),
        react_1.default.createElement(PusherContext_1.default.Provider, { value: ctx }, child)));
};
exports.default = react_1.memo(Pusher);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
